import { computed } from 'vue';
import type { ComputedRef } from 'vue';
import type { CompanyPermissionsCodename } from 'src/api';
import { useUser } from 'stores/user/useUser';

// `src/api` is generated from the backend schema; until it is regenerated the new codename
// is not in the enum yet. Swap this for `CompanyPermissionsCodename.ALLOW_SUBSCRIPTION_CARD_PAYMENT`
// after running `yarn generate-api:*`.
const ALLOW_SUBSCRIPTION_CARD_PAYMENT =
  'allow_subscription_card_payment' as CompanyPermissionsCodename;

/**
 * Whether the company may pay its subscription by card. When off, the whole card flow
 * (payment-method page, card option at checkout, card charges) is hidden and the tenant
 * keeps paying by bank transfer only.
 */
export const useCardPaymentEnabled = (): ComputedRef<boolean> => {
  const userStore = useUser();
  return computed(() =>
    userStore.handleCompanyHasPermission(ALLOW_SUBSCRIPTION_CARD_PAYMENT)
  );
};
